import * as z from "zod";

export const ATTACHMENT_MIME_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
] as const;

export type AttachmentMimeType = (typeof ATTACHMENT_MIME_TYPES)[number];

export const MAX_ATTACHMENT_SIZE_BYTES = 5 * 1024 * 1024;

export const attachmentTypeSchema = z.enum([
  "challenge",
  "payout",
  "invoice",
  "other",
]);
export type AttachmentType = z.infer<typeof attachmentTypeSchema>;

const MAGIC_BYTES: Record<AttachmentMimeType, number[][]> = {
  "application/pdf": [[0x25, 0x50, 0x44, 0x46]], // %PDF
  "image/png": [[0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]],
  "image/jpeg": [
    [0xff, 0xd8, 0xff, 0xe0],
    [0xff, 0xd8, 0xff, 0xe1],
    [0xff, 0xd8, 0xff, 0xdb],
    [0xff, 0xd8, 0xff, 0xee],
  ],
};

export function validateMagicBytes(
  buffer: Buffer,
  mimeType: AttachmentMimeType,
): boolean {
  const signatures = MAGIC_BYTES[mimeType];
  if (!signatures) return false;
  return signatures.some((sig) =>
    sig.every((byte, i) => buffer[i] === byte),
  );
}
